import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for when the receiving team recovers a bar ball (Indoor Football).
 * A bar ball is when a kickoff hits the goalpost. If the receiving team recovers,
 * they gain possession at the recovery spot.
 */
export default class BarBallRecoveredReceiving extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.BarBallRecoveredReceiving
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredBy, recoveredAt } = fragment;

        // Receiving team gains possession
        if (recoveredBy) {
            gameContext.setPossessionForTeamId(recoveredBy.teamId);
            gameContext.setCurrentPlayerInPossession(recoveredBy);
        }
        if (recoveredAt || recoveredAt === 0) {
            gameContext.setFieldPosition(recoveredAt);
        }
        ruleContext.setAwardFirstDown(true);
    }
}
